import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import DisposalList from './DisposalList';

// Read-only — the service exposes no PUT for /disposaling. See
// readydispose/index.js for the full rationale. DisposalEdit.js is retained
// for when a disposal write endpoint exists.
export default {
    list: DisposalList,
    icon: DeleteForeverIcon,
};
